import { hMacAjax as fetch } from 'grt-tool-lib-front';
export interface RequestResultType {
    success: boolean;
    code: string;
    msg: string;
    data: any;
    total?: number;
}
export class Request {
    static get<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        return fetch.get(url, params, { headers });
    }

    static post<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        return fetch.post(url, params, { headers });
    }

    static delete<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        return fetch.delete(url, params, { headers });
    }

    static put<T>(url: string, params: any = {}, headers: any = {}): Promise<T> {
        return fetch.put(url, params, { headers });
    }
    static axios = fetch.request;
}
